window.bootstrap = require("bootstrap");
import "@/js/modules/correctVh";
import "@/js/modules/openMenu";
import "@/js/modules/animationOnScroll";
import "@/js/modules/lozad";
import "@/js/modules/redirectToApp";
// import "@/js/modules/starsRating";
import "@/js/modules/customSelect";
import "@/js/modules/communitySlider";
// import "@/js/modules/footerDisclaimer";
// import "@/js/modules/partnersLoader";
import "@/js/modules/btnApply"; // ?
// import "@/js/modules/modalAutoAppearing";
import "@/js/modules/swiperFeaturedArticles";
import "@/js/modules/pwa_analytics";
